import React from 'react'

import { RouteProps } from '@sketch/constants'

// Components
import useUserProfile from 'modules/user/useUserProfile'
import NotFoundView from 'views/NotFoundView'

// Local Components
import { PublicProfileHeader } from '../components/PublicProfileHeader'
import { WorkspaceProfileLayout } from '../containers/WorkspaceProfileLayout'
import { ProfileInfo } from '../components/ProfileInfo'

// Local Hooks
import { useGetWorkspaceProfile } from '../hooks/useGetWorkspaceProfile'

interface WorkspaceProfilePublicViewProps
  extends RouteProps<'WORKSPACE_PROFILE'> {}

const WorkspaceProfilePublicView = (props: WorkspaceProfilePublicViewProps) => {
  const { workspaceId } = props.match.params

  const profileResult = useGetWorkspaceProfile(workspaceId)

  const { data } = useUserProfile()
  const user = data?.me

  if (profileResult.error) {
    return <NotFoundView />
  }

  return (
    <div>
      <PublicProfileHeader
        workspaceId={workspaceId}
        profileResult={profileResult}
        user={user}
      />
      <WorkspaceProfileLayout
        workspaceId={workspaceId}
        isProfileEditRoute={false}
        profileResult={profileResult}
        profileInfo={<ProfileInfo profile={profileResult.profile || {}} />}
      />
    </div>
  )
}

export default WorkspaceProfilePublicView
